import { useTheme } from 'contexts'
import React from 'react'

import { Box } from 'widgets/Box'

import { SpacingTypes, ThemeColor } from 'utils/themes/types'

type PageIndicatorProps = {
  size: SpacingTypes
  pagesCount: number
  selectedIndex: number
  selectedColor: ThemeColor
  unselectedColor: ThemeColor
}

export const PageIndicator = ({
  size,
  pagesCount,
  selectedIndex,
  selectedColor,
  unselectedColor,
}: PageIndicatorProps) => {
  const theme = useTheme()

  return (
    <Box flexDirection='row'>
      {[...Array(pagesCount).keys()].map((index) => {
        return (
          <Box
            key={index}
            margin='xs'
            borderRadius='xl'
            width={theme.spacing[size]}
            height={theme.spacing[size]}
            backgroundColor={selectedIndex === index ? selectedColor : unselectedColor}
          />
        )
      })}
    </Box>
  )
}
